import React from 'react';
import Col from 'react-bootstrap/Col';
import './training-details-header.scss'
function TraningDetailsHeader({text}) {
  return (
    <Col xs={12} className="text-content-container review-shopping">
      <div className="text-content background transparent">
        <div className="inner-wrapper  trinity-container">
          <p className="m-0 review-shopping-header">{text}</p>
        </div>
      </div>
    </Col>
  );
}

export default TraningDetailsHeader;